import { inject, injectable } from 'inversify';
import { Store } from 'vuex';
import { DEPENDENCIES } from '../container/dependencies.const';
import { ClientEvent } from '../models';
import { RootStoreState } from '../store';
import { ClientEventsDispatcher } from './services.types';

@injectable()
export class DefaultClientEventsDispatcherService implements ClientEventsDispatcher {

  @inject(DEPENDENCIES.Store)
  protected readonly store: Store<RootStoreState>;

  dispatch(event: ClientEvent): void {
    const eventCallback = this.getEventCallback(event.eventName);
    eventCallback?.(event.data);
  }

  protected getEventCallback(eventName: string): ((data: any) => void) | null {
    const callback = this.store.state.config.dynamic?.eventCallbacks?.[eventName];
    return callback instanceof Function ? callback : null;
  }
}
